import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3l0 -8","key":"svg-0"}],["path",{"d":"M3 10l18 0","key":"svg-1"}],["path",{"d":"M7 15l.01 0","key":"svg-2"}],["path",{"d":"M11 15l2 0","key":"svg-3"}]]

const IconCreditCard = createReactComponent('outline', 'credit-card', 'CreditCard', __iconNode);

export default IconCreditCard;